// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetReportIsScrollable = () => false;

const toggleReportIsScrollable = () => true;

export default (state = getDefaultState().reportIsScrollable, action) => {

    const actionTypes = {
        [actions.RESET_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE]: resetReportIsScrollable,
        [actions.TOGGLE_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE]: toggleReportIsScrollable
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/report-is-scrollable.js